module.exports = __webpack_public_path__ + "static/media/ATLAS.162356a4.png";